import React,{useMemo} from "react";
import { Box } from "@chakra-ui/react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./Styles/AgGridWrapper.css";

function AgGridWrapper({
  rowData = [],
  columnDefs = [],
  loading = false,
  onGridReady,
  onFilterChanged,
  height = "590px",
  rowHeight,
  extraGridProps = {},
  noRowsMessage = "No data available. Please load data to view results.",
  domLayout = "normal",

}) {

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      filterParams: { maxNumConditions: 1, buttons: ["reset"] },
      resizable: true,
      minWidth: 120,
      suppressHeaderMenuButton: false,
      menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderMenuButton: false,
      rowDrag: false,   
      suppressMovable: true, 
      cellStyle: {                       
      display: "flex",
      alignItems: "center",
      lineHeight: "normal",
     },
   }),
 
    []
  );
  
  const computedRowHeight =
    rowHeight ?? (window.innerWidth < 768 ? 60 : 64);
 
  const overlayNoRowsTemplate = `
    <span style="color:#9ca3af;font-size:15px;font-weight:500;">
      ${noRowsMessage}
    </span>`;
 
  return (
    <Box className="ag-theme-alpine" style={{ height: domLayout === "autoHeight" ? "auto" : height, width: "100%" }}boxShadow="0 2px 8px rgba(0, 0, 0, 0.1)" bg="white"
        borderRadius={{ base: "6px", md: "8px" }}  overflow="hidden">
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        loading={loading}
        onGridReady={onGridReady}
        onFilterChanged={onFilterChanged}
        animateRows={false}
        rowHeight={computedRowHeight}
        enableCellTextSelection={true}
         suppressCellFocus={true}
        ensureDomOrder={true}
        suppressRowClickSelection={true}
        overlayNoRowsTemplate={overlayNoRowsTemplate}
        {...extraGridProps}
        domLayout={domLayout}
        style={{ height: domLayout === "autoHeight" ? undefined : "100%", width: "100%" }}

      />
    </Box>
  );
}
 
export default AgGridWrapper;
